<template>
    <div>
        <v-menu
            ref="menu"
            close-on-click
            close-on-content-click
        >
            <template v-slot:activator="{ on }">
                <v-btn
                    :class="{primary: hasActiveElement, white:!hasActiveElement}"
                    fab
                    elevation="3"
                    x-small
                    v-on="on"
                    @mousemove.stop
                    @mousedown.stop
                    @mouseover.stop
                >
                    {{ elements.length }}
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item
                    v-for="(element,index) in elements"
                    :key="index"
                    :class="{primary: isActiveElement(element)}"
                    @click="setActiveElement(element)"
                >
                    <v-list-item-title>{{ formatElement(element) }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import TimeHelper from '@/time-helper';

    export default {
        name: 'CommentsExternalScrubPlotGroup',
        props: ['elements'],
        computed: {
            ...mapGetters('comments', ['activeElement']),
            hasActiveElement() {
                let active = false;
                this.elements.forEach(element => {
                    active = active || this.isActiveElement(element);
                });
                return active;
            }
        },
        methods: {
            ...mapMutations('comments', ['setActiveElement']),
            isActiveElement(element) {
                return element === this.activeElement;
            },
            formatElement(element) {
                return TimeHelper.fromMsToHisU(element * 1000);
            }
        }
    };
</script>

<style scoped>
    .v-btn.white {
        border: 2px solid gray !important;
    }
</style>
